import React from "react";
import { JsonLd } from "react-schemaorg";
import { CreativeWork } from "schema-dts";

interface PaywallMarkupProps {
    cssSelector: string;
}

export function PaywallMarkup({ cssSelector }: PaywallMarkupProps): JSX.Element {
    return (
        <JsonLd<CreativeWork>
            item={{
                "@context": "https://schema.org",
                "@type": "CreativeWork",
                isAccessibleForFree: "False",
                hasPart: {
                    "@type": "WebPageElement",
                    isAccessibleForFree: "False",
                    cssSelector: `.${cssSelector}`,
                },
            }}
        />
    );
}

export default PaywallMarkup;
